module.exports = __webpack_public_path__ + "img/sectigo_trust_seal.080e0f3.png";